// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__1z3Kj","imageUploader":"EGiftCard_imageUploader__BeJwb"};